import React from 'react'
import styled from 'styled-components';

function Video() {
  return (
    <Root id="video">
      {/* TODO(vimeo→r2): replace this Vimeo iframe with a direct player. Video:  https://media.bamdigital.com/shape/tab5-1080p.mp4 Poster: https://media.bamdigital.com/shape/tab5.jpg */}
      <iframe src="https://player.vimeo.com/video/604331116?h=8700ca6d98&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479&amp;loop=1" title="TAB5"></iframe><script src="https://player.vimeo.com/api/player.js"></script>
    </Root>
  )
}

const Root = styled.section`
  position: relative;
  width: 100%;
  height: auto;
  padding: 56.25% 0 0 0;

  iframe{
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border: 0;
  }
`;

export default Video
